































































































































































































import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import SolicitacaoPendenciaStore from '@/components/SolicitacaoPendencia/Store/SolicitacaoPendenciaStore'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import BackofficeAgendamentoStore from '@/components/Backoffice/Store/BackofficeAgendamentoStore'
import ContestacaoMedicaStore from '@/components/ContestacaoMedica/Store/ContestacaoMedicaStore'
import BackofficeDataAgendamentoStore from '@/components/Backoffice/Store/BackofficeDataAgendamentoStore'
import SolicitacaoCancelamentoStore from '@/components/SolicitacaoCancelamento/Store/SolicitacaoCancelamentoStore'
import ChatStore from '@/components/Chat/Store/ChatStore'
import { AgendamentoCirurgia, IRequestMessage, RequestMessage, AgendamentoSolicitacaoItem, CancelarSolicitacaoParam, TipoOrigemEnum } from '@/types/_'
import { Agendamento, Autorizacao, PreAnestesia } from '@/types/core'
import AgendamentoApi from '@/Apis/Agendamento/Agendamento'
import EventBus from '@/plugins/EventBus'
import { verifyAcaoPrincipalAgendamento, backofficeRoute, timeout, base64toBlob, syncWhatsAppFlagFromPost } from '@/utils/common'
import { permissionService } from '@/services/permission.service'
import { backofficeSharedDataService } from './Store/backoffice-shared-data-service'

@Component

export default class ComponentBackofficeActionButtons extends Vue {
  @Prop() agendamento: AgendamentoCirurgia

  agd: any = new Agendamento.Agendamento()
  aut: any = new Autorizacao.Autorizacao()
  preAnestesia: any = new PreAnestesia.PreAnestesia()

  getRequestMessage: IRequestMessage = new RequestMessage()

  loadVoltarStatus: boolean = false
  loadRealizarTriagem: boolean = false
  loadRealizarCancelamento: boolean = false
  loadAlterarSolicitacao: boolean = false
  loadIniciarProcesso: boolean = false
  loadVisualizar: boolean = false
  loadAutorizarProcesso: boolean = false
  loadRealizarAvaliacao: boolean = false
  loadAlterarCotacao: boolean = false
  loadResolverContestacao: boolean = false
  loadEmCotacaoSolicitacao: string = ''
  loadNovaDataSolicitada: string = ''
  loadImprimirEtiqueta: string = ''
  showModalGerenciarCirurgiaConjunta: boolean = false
  loadingEnviarMensagemMedico: string = ''

  get loadingImprimirEtiqueta() {
    return this.loadImprimirEtiqueta
  }

  set loadingImprimirEtiqueta(value: string) {
    this.loadImprimirEtiqueta = value
  }

  get loadingNovaDataSolicitada() {
    return this.loadNovaDataSolicitada
  }

  set loadingNovaDataSolicitada(value: string) {
    this.loadNovaDataSolicitada = value
  }

  get loadingVoltarStatus() {
    return this.loadVoltarStatus
  }

  set loadingVoltarStatus(value: boolean) {
    this.loadVoltarStatus = value
  }

  get loadingAutorizarProcesso() {
    return this.loadAutorizarProcesso
  }

  set loadingAutorizarProcesso(val: boolean) {
    this.loadAutorizarProcesso = val
  }

  get loadingRealizarTriagem() {
    return this.loadRealizarTriagem
  }

  set loadingRealizarTriagem(value: boolean) {
    this.loadRealizarTriagem = value
  }

  get loadingRealizarCancelamento() {
    return this.loadRealizarCancelamento
  }

  set loadingRealizarCancelamento(value: boolean) {
    this.loadRealizarCancelamento = value
  }

  get loadingAlterarSolicitacao() {
    return this.loadAlterarSolicitacao
  }

  set loadingAlterarSolicitacao(value: boolean) {
    this.loadAlterarSolicitacao = value
  }

  get loadingIniciarProcesso() {
    return this.loadIniciarProcesso
  }

  set loadingIniciarProcesso(value: boolean) {
    this.loadIniciarProcesso = value
  }

  get loadingVisualizar() {
    return this.loadVisualizar
  }

  set loadingVisualizar(val: boolean) {
    this.loadVisualizar = val
  }

  get loadingRealizarAvaliacao() {
    return this.loadRealizarAvaliacao
  }

  set loadingRealizarAvaliacao(value: boolean) {
    this.loadRealizarAvaliacao = value
  }

  get loadingAlterarCotacao() {
    return this.loadAlterarCotacao
  }

  set loadingAlterarCotacao(value: boolean) {
    this.loadAlterarCotacao = value
  }

  get loadingResolverContestacao() {
    return this.loadResolverContestacao
  }

  set loadingResolverContestacao(value: boolean) {
    this.loadResolverContestacao = value
  }

  get getSolicitacaoCancelamentoStore() {
    return getModule(SolicitacaoCancelamentoStore, this.$store)
  }

  get getSolicitacaoPendenciaStore() {
    return getModule(SolicitacaoPendenciaStore, this.$store)
  }

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get getBackofficeAgendamentoStore() {
    return getModule(BackofficeAgendamentoStore, this.$store)
  }

  get getBackofficeDataAgendamentoStore() {
    return getModule(BackofficeDataAgendamentoStore, this.$store)
  }

  get getContestacaoMedicaStore() {
    return getModule(ContestacaoMedicaStore, this.$store)
  }

  get getChatStore() {
    return getModule(ChatStore, this.$store)
  }

  get loadingEmCotacaoSolicitacao() {
    return this.loadEmCotacaoSolicitacao
  }

  set loadingEmCotacaoSolicitacao(value: string) {
    this.loadEmCotacaoSolicitacao = value
  }

  async showModalNovaDataSolicitada(agendamentoItem: AgendamentoSolicitacaoItem) {
    this.loadingNovaDataSolicitada = agendamentoItem.id

    await this.getBackofficeGlobalStore.getSolicitacaoById(agendamentoItem.id)

    if (this.getBackofficeGlobalStore.componentToConfirmReservation === 'BackofficeConfirmarReservaSala') {
      const response = await this.getBackofficeGlobalStore.bloquearSolicitacao(agendamentoItem.id)
      if (response.success) {
        await this.getChatStore.getDataAgendamento(agendamentoItem.id)
        await this.getBackofficeGlobalStore.getHospitalTemplate(agendamentoItem.hospitalId)
        this.getBackofficeGlobalStore.setModal({ name: 'reservaDeSala', value: true })
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: response.message, icon: 'warning', color: '#C62828' })
      }
    } else {
      await this.getChatStore.getDataAgendamento(agendamentoItem.id)
      await this.getBackofficeDataAgendamentoStore.setAgendamentoItem({ ...agendamentoItem })
      this.getBackofficeDataAgendamentoStore.setModal({ name: 'confirmarDataAgendamento', value: true })
    }

    this.loadingNovaDataSolicitada = ''
    this.ga('backoffice-agendamento', 'confirmar-data')
  }

  verifyButtonExists(className: string) {
    return !!document.querySelector(`.${className}`)
  }

  //

  verifyAcaoPrincipal(item: any) {
    return verifyAcaoPrincipalAgendamento(item)
  }

  // Associar/desassociar cirurgia conjunta muda `ehCirurgiaConjunta`/`cirurgiasConjuntas`
  // desta linha sem passar pelo fluxo normal de recarregamento da listagem — resincroniza
  // só esses campos, mesmo padrão do resync de WhatsApp em showModalTriagem.
  async syncCirurgiaConjuntaDoAgendamento() {
    const response = await this.getBackofficeAgendamentoStore.loadAgendamentosMedicoSearch(this.agendamento.id)

    if (!response.success || !response.data || !response.data.solicitacoes) {
      return
    }

    const solicitacaoAtualizada = response.data.solicitacoes.find((s: any) => s.id === this.agendamento.id)

    if (!solicitacaoAtualizada) {
      return
    }

    this.agendamento.ehCirurgiaConjunta = solicitacaoAtualizada.ehCirurgiaConjunta
    this.agendamento.cirurgiasConjuntas = solicitacaoAtualizada.cirurgiasConjuntas
  }

  async showModalVoltarStatus(agendamentoCirurgia: AgendamentoCirurgia) {
    this.loadingVoltarStatus = true
    await timeout(500)
    this.getBackofficeGlobalStore.setAgendamentoMedicoId(agendamentoCirurgia.id)
    this.getBackofficeGlobalStore.setShowModalVoltarStatus(true)
    this.loadingVoltarStatus = false
  }

  async showModalTriagem(agendamentoCirurgia: AgendamentoCirurgia) {
    this.loadingRealizarTriagem = true

    const response = await this.agd.bloquearSolicitacao(agendamentoCirurgia.id)
    if (response.success) {
      await this.getBackofficeGlobalStore.getHospitalTemplate(agendamentoCirurgia.hospitalId)
      const request = await this.getBackofficeGlobalStore.getSolicitacaoById(agendamentoCirurgia.id)
      if (request.success) {
        // Sincronizar flag WhatsApp do POST endpoint
        const responseAgendamentos = await this.getBackofficeAgendamentoStore.loadAgendamentosMedicoSearch(agendamentoCirurgia.id)
        if (responseAgendamentos.success && responseAgendamentos.data && responseAgendamentos.data.solicitacoes) {
          const solicitacaoDoPost = responseAgendamentos.data.solicitacoes.find((s: any) => s.id === agendamentoCirurgia.id)
          if (solicitacaoDoPost) {
            syncWhatsAppFlagFromPost(request.data, solicitacaoDoPost)
            this.$store.commit('BackofficeGlobalStore/setSolicitacao', request.data)
          }
        }

        this.getBackofficeGlobalStore.setModal({ name: 'triagem', value: true })
        this.ga('backoffice-agendamento', 'abrir-modal-triagem')
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: request.message, icon: 'warning', color: '#C62828' })
      }
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message, icon: 'warning', color: '#C62828' })
    }

    this.loadingRealizarTriagem = false
  }

  get implemantation() {
    switch (this.$route.name) {
      case 'BackofficeAgendamento':
        return 'agd'
      case 'BackofficeAutorizacao':
        return 'aut'
      default:
        return 'agd'
    }
  }

  async showModalAlterarSolicitacao(agendamentoCirurgia: AgendamentoCirurgia) {
    this.loadingAlterarSolicitacao = true

    const response = await this[this.implemantation].bloquearSolicitacao(agendamentoCirurgia.id)
    if (response.success) {
      await this.getBackofficeGlobalStore.getHospitalTemplate(agendamentoCirurgia.hospitalId)
      const request = await this.getBackofficeGlobalStore.getSolicitacaoAlteradaById(agendamentoCirurgia.id)
      if (request.success) {
        const template = this.getBackofficeGlobalStore.template.formulario
        backofficeSharedDataService.solicitacaoAlterada = this.getBackofficeGlobalStore.solicitacaoAlterada

        const hospitalUsesAnesthesiaClinic = template
          && template.anestesiaHospital
          && template.anestesiaHospital.habilitado
          && template.anestesiaHospital.campos.hospitalUtilizaClinicasDeAnestesia

        if (hospitalUsesAnesthesiaClinic) {
          await this.getBackofficeGlobalStore.getClinicasDeAnestesia({ hospitalId: agendamentoCirurgia.hospitalId })
          if (this.getBackofficeGlobalStore.solicitacaoAlterada.nomeAnestesista) {
            this.getBackofficeGlobalStore.setSolicitacaoAlteradaFields({
              field: 'anestesista',
              value: 'Outros',
            })
            this.getBackofficeGlobalStore.setOutroAnestesista(this.getBackofficeGlobalStore.solicitacaoAlterada.nomeAnestesista)
          }
        }

        await Promise.all([
          this.getBackofficeGlobalStore.getAllHospitais(),
          this.getBackofficeGlobalStore.getProcedimentosBackofficeSearch(''),
          this.getBackofficeGlobalStore.getAllConvenios(agendamentoCirurgia.hospitalId),
          this.getBackofficeGlobalStore.getAllPlanos({ hospitalId: agendamentoCirurgia.hospitalId, convenioId: agendamentoCirurgia.convenioId }),
          this.getBackofficeGlobalStore.getAllCategoriasByPlano({ hospitalId: agendamentoCirurgia.hospitalId, convenioId: agendamentoCirurgia.convenioId, planoId: agendamentoCirurgia.planoId }),
          this.getBackofficeGlobalStore.getReservaHemocomponente(),
          backofficeSharedDataService.loadMaterialOptions(),
          backofficeSharedDataService.loadFornecedorOptions(),
        ])

        const requestHasAnesthesiaClinic = this.getBackofficeGlobalStore.solicitacaoAlterada.anestesista && typeof this.getBackofficeGlobalStore.solicitacaoAlterada.anestesista !== 'string'
        if (hospitalUsesAnesthesiaClinic && requestHasAnesthesiaClinic && this.getBackofficeGlobalStore.clinicasDeAnestesia.data) {
          const clinicSelected = this.getBackofficeGlobalStore.clinicasDeAnestesia.data.find(clinic => clinic.id === this.getBackofficeGlobalStore.solicitacaoAlterada.anestesista.id)
          if (clinicSelected) {
            this.getBackofficeGlobalStore.setSolicitacaoAlteradaFields({
              field: 'anestesista',
              value: clinicSelected,
            })
          }
        }

        if (this.getBackofficeGlobalStore.solicitacaoAlterada.hospital.utilizaTipoAcomodacaoHospital) {
          await this.getBackofficeGlobalStore.getAllTipoAcomodacao(agendamentoCirurgia.hospitalId)
        }

        this.getBackofficeGlobalStore.setModal({ name: 'alterarSolicitacao', value: true })
        this.ga('backoffice-agendamento', 'abrir-modal-alterar-solicitacao')
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: request.message || 'Ocorreu um erro ao requisitar a solicitação', icon: 'warning', color: '#C62828' })
      }
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message, icon: 'warning', color: '#C62828' })
    }

    this.loadingAlterarSolicitacao = false
  }

  async showModalIniciarProcesso(agendamentoCirurgia: AgendamentoCirurgia) {
    this.loadingIniciarProcesso = true

    const response = await this.aut.bloquearSolicitacao(agendamentoCirurgia.id)
    if (response.success) {
      await this.getBackofficeGlobalStore.getHospitalTemplate(agendamentoCirurgia.hospitalId)
      const request = await this.getBackofficeGlobalStore.getSolicitacaoById(agendamentoCirurgia.id)
      if (request.success) {
        // Sincronizar flag WhatsApp do POST endpoint
        const responseAgendamentos = await this.getBackofficeAgendamentoStore.loadAgendamentosMedicoSearch(agendamentoCirurgia.id)
        if (responseAgendamentos.success && responseAgendamentos.data && responseAgendamentos.data.solicitacoes) {
          const solicitacaoDoPost = responseAgendamentos.data.solicitacoes.find((s: any) => s.id === agendamentoCirurgia.id)
          if (solicitacaoDoPost) {
            syncWhatsAppFlagFromPost(request.data, solicitacaoDoPost)
            this.$store.commit('BackofficeGlobalStore/setSolicitacao', request.data)
          }
        }

        this.getBackofficeGlobalStore.setModal({ name: 'iniciarProcesso', value: true })
        this.ga('backoffice-autorizacao', 'abrir-modal-iniciar-processo')
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: request.message, icon: 'warning', color: '#C62828' })
      }
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message, icon: 'warning', color: '#C62828' })
    }

    this.loadingIniciarProcesso = false
  }

  async showModalVisualizacao(agendamentoCirurgia: AgendamentoCirurgia) {
    this.loadingVisualizar = true

    this.getBackofficeGlobalStore.setBackofficeArea(backofficeRoute())
    this.getBackofficeGlobalStore.setSolicitacaoId(agendamentoCirurgia.id)
    this.getBackofficeGlobalStore.setModal({ name: 'visualizacao', value: true })

    this.ga('backoffice-agendamento', 'visualizar-pendencia-triagem')
    this.loadingVisualizar = false
  }

  ga(event: string, action: string) {
    this.$ga.event(event, action, this.$user.profile.email)
  }

  async emCotacaoSolicitacao(agendamentoCirurgia: AgendamentoCirurgia) {
    const solicitacaoId = agendamentoCirurgia.id
    this.loadingEmCotacaoSolicitacao = solicitacaoId

    let response = await this.aut.bloquearSolicitacao(solicitacaoId)
    if (response.success) {
      await this.getBackofficeGlobalStore.getHospitalTemplate(agendamentoCirurgia.hospitalId)
      response = await this.getBackofficeGlobalStore.getSolicitacaoById(solicitacaoId)
      if (response.success) {
        this.getBackofficeGlobalStore.setModal({ name: 'atualizarAutorizacao', value: true })
        this.ga('backoffice-autorizacao', 'em-autorizacao')
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: response.message, icon: 'warning', color: '#C62828' })
      }
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message, icon: 'warning', color: '#C62828' })
    }

    this.loadingEmCotacaoSolicitacao = ''
  }

  async autorizarProcesso(agendamentoCirurgia: AgendamentoCirurgia) {
    this.loadingAutorizarProcesso = true
    const solicitacaoId = agendamentoCirurgia.id

    let response = await this.aut.bloquearSolicitacao(solicitacaoId)
    if (response.success) {
      await this.getBackofficeGlobalStore.getHospitalTemplate(agendamentoCirurgia.hospitalId)
      response = await this.getBackofficeGlobalStore.getSolicitacaoById(solicitacaoId)
      if (response.success) {
        this.getBackofficeGlobalStore.setModal({ name: 'autorizarProcesso', value: true })
        this.ga('backoffice-autorizacao', 'autorizar-solicitacao')
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: response.message, icon: 'warning', color: '#C62828' })
      }
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message, icon: 'warning', color: '#C62828' })
    }

    this.loadingAutorizarProcesso = false
  }

  canRenovarAutorizacaoOperadora(agendamentoCirurgia: AgendamentoCirurgia) {
    return agendamentoCirurgia.acoes.permiteRenovarAutorizacaoOperadora === true
  }

  renovarAutorizacaoOperadora(agendamentoCirurgia: AgendamentoCirurgia) {
    this.$emit('renovarAutorizacao', agendamentoCirurgia)
  }

  async resolverContestacao(agendamentoCirurgia: AgendamentoCirurgia) {
    this.loadingResolverContestacao = true
    await this.getBackofficeGlobalStore.getHospitalTemplate(agendamentoCirurgia.hospitalId)
    const request = await this.getBackofficeGlobalStore.getContestacaoMedica(agendamentoCirurgia.id)
    if (request.success) {
      this.getBackofficeGlobalStore.setSolicitacaoId(agendamentoCirurgia.id)
      this.getBackofficeGlobalStore.setModal({ name: 'contestacaoMedica', value: true })
    }
    this.loadingResolverContestacao = false
  }

  async realizarAvaliacao(agendamentoCirurgia: AgendamentoCirurgia) {
    this.loadingRealizarAvaliacao = true

    const response = await this.preAnestesia.bloquearSolicitacao(agendamentoCirurgia.id)
    if (response.success) {
      await this.getBackofficeGlobalStore.closeModalRealizarAvaliacao()
      await this.getBackofficeGlobalStore.getHospitalTemplate(agendamentoCirurgia.hospitalId)
      const request = await this.getBackofficeGlobalStore.getSolicitacaoById(agendamentoCirurgia.id)
      if (request.success) {
        this.getBackofficeGlobalStore.setModal({ name: 'realizarAvaliacao', value: true })
        this.ga('backoffice-pre-anestesia', 'abrir-modal-realizar-avaliacao')
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: request.message, icon: 'warning', color: '#C62828' })
      }
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message, icon: 'warning', color: '#C62828' })
    }

    this.loadingRealizarAvaliacao = false
  }

  async showModalRealizarCancelamento(agendamentoCirurgia: AgendamentoCirurgia) {
    this.loadingRealizarCancelamento = true
    const cancelarSolicitacaoParam: CancelarSolicitacaoParam = {
      solicitacaoId: agendamentoCirurgia.id,
      tipoOrigem: TipoOrigemEnum.Agendamento,
      situacao: agendamentoCirurgia.situacao,
      canceladoMotivo: {
        display: '',
        key: '',
      },
      modal: 'geral',
    }

    await this.getSolicitacaoCancelamentoStore.getMotivosCancelamentoAll({ hospitalId: agendamentoCirurgia.hospitalId })
    this.getSolicitacaoCancelamentoStore.setCancelarSolicitacaoParam(cancelarSolicitacaoParam)
    this.getSolicitacaoCancelamentoStore.setShowModalCancelamentoGeral(true)
    this.ga('backoffice-agendamento', 'abrir-modal-motivo-cancelamento')
    this.loadingRealizarCancelamento = false
  }

  async enviarMensagemMedico(agendamentoCirurgia: AgendamentoCirurgia) {
    try {
      this.loadingEnviarMensagemMedico = agendamentoCirurgia.id

      const response = await AgendamentoApi.AgendamentoMedicoBackofficeApi.enviarNotificacaoWhatsapp(agendamentoCirurgia.id, {
        etapaDeNotificacao: 'AguardandoAprovacaoOrcamento',
      })

      if (response.success) {
        EventBus.$emit('setSnackbar', { show: true, text: 'Mensagem enviada ao médico com sucesso', icon: 'check_circle', color: '#43A047' })
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Erro ao enviar mensagem ao médico', icon: 'warning', color: '#C62828' })
      }
    } catch (error) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Erro ao enviar mensagem ao médico', icon: 'warning', color: '#C62828' })
    } finally {
      this.loadingEnviarMensagemMedico = ''
    }
  }

  async atualizarTriagem(agendamentoCirurgia: AgendamentoCirurgia) {
    //
  }

  async alterarCotacao(agendamentoCirurgia: AgendamentoCirurgia) {
    this.loadingAlterarCotacao = true
    await this.getBackofficeGlobalStore.getSolicitacaoById(agendamentoCirurgia.id)
    this.getBackofficeGlobalStore.setModal({ name: 'alterarCotacao', value: true })
    this.ga('backoffice-autorizacao', 'alterar-cotacao')
    this.loadingAlterarCotacao = false
  }

  async imprimirEtiqueta(agendamentoCirurgia: AgendamentoCirurgia) {
    this.loadingImprimirEtiqueta = agendamentoCirurgia.id
    const request = await this.getBackofficeGlobalStore.imprimirEtiqueta(agendamentoCirurgia.id)
    if (request.success && request.data && request.data.file) {
      // window.open(`data:application/pdf;base64, ${request.data.file}`, '_blank')
      // const linkSource = `data:application/pdf;base64, ${request.data.file}`
      // const downloadLink = document.createElement('a')
      // const fileName = 'etiqueta.pdf'
      // downloadLink.href = linkSource
      // downloadLink.download = fileName
      // downloadLink.click()
      // downloadLink.remove()
      const blob = base64toBlob(request.data.file)
      const blobUrl = URL.createObjectURL(blob)
      window.open(blobUrl)
    }
    // this.getBackofficeGlobalStore.setModal({ name: 'imprimirEtiqueta', value: true })
    this.loadingImprimirEtiqueta = ''
  }

  @Emit('setLoadingRequest')
  setLoadingRequest(status, text) { }

  @Emit('clearLoadingRequest')
  clearLoadingRequest() { }

  get backofficeArea() {
    return window.localStorage.getItem('backofficeArea')
  }

  get canChangeSolicitacao() {
    return !permissionService.hasPermission('agendamento.backoffice.solicitacao.naoAlterar')
  }
}
